var React = require('react');

function mobileFilterIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Filter"),React.createElement("path",{"fill":"#C4CDD7","fillRule":"evenodd","d":"M19.962 4.217A.379.379 0 0 0 19.62 4H4.379a.379.379 0 0 0-.34.217.392.392 0 0 0 .042.408l5.294 6.87c.252.328.391.737.391 1.153v5.256c0 .152.087.29.223.352l3.71 1.71a.373.373 0 0 0 .361-.028.388.388 0 0 0 .174-.324v-6.966c0-.416.139-.825.39-1.152l5.295-6.871a.392.392 0 0 0 .043-.408z","key":1})]);
}

mobileFilterIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img"};

module.exports = mobileFilterIcon;

mobileFilterIcon.default = mobileFilterIcon;
